import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Payroll() {
  const navigate = useNavigate();

  const cards = [
    { icon: '💰', title: 'Generate Pay Slip', desc: 'Create and print employee pay slips based on salary and pay frequency.', path: '/payslip' },
    { icon: '🏦', title: 'Write Check', desc: 'Write and print checks to vendors, employees, or other payees.', path: '/banking/write-check' },
    { icon: '👥', title: 'Manage Employees', desc: 'View and manage employee records, salaries, and pay frequencies.', path: '/employees' },
    { icon: '🔄', title: 'Recurring Payroll', desc: 'Set up automatic recurring payroll runs for selected employees.', path: '/recurring' },
  ];

  return (
    <div>
      <div className="toolbar"><h2>💰 Payroll</h2></div>
      <div className="stats-grid" style={{ marginBottom: 20 }}>
        {cards.map(c => (
          <div key={c.title} className="stat-card primary" style={{ cursor: 'pointer', padding: 20 }} onClick={() => navigate(c.path)}>
            <div style={{ fontSize: 28, marginBottom: 8 }}>{c.icon}</div>
            <div className="stat-label" style={{ fontSize: 13, fontWeight: 700, textTransform: 'none', letterSpacing: 0 }}>{c.title}</div>
            <div style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>{c.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
